module.exports = __webpack_public_path__ + "static/img/stamp_13.24129fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_13.jpg
// module id = NitU
// module chunks = 7